import styled from "styled-components";

export const TextEditorContainer = styled.div`
  /* border: 1px solid gray; */
  border-radius: 10px;
  /* padding: 10px; */

  height: 100%;

  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};

  .rdw-editor-toolbar {
    border: none;
  }

  .rdw-editor-wrapper {
    margin: 5px 0px;
    border: 1px solid ${({ theme }) => theme.colors.neutral.gray4};
    border-radius: 4px;
    position: relative;

    ${({ disabled }) =>
      disabled &&
      `
      pointer-events: none;
      
      ::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(206 211 231);
        opacity: 0.5;
        z-index: 6;
      }
    `}
  }

  .DraftEditor-editorContainer {
    min-height: 200px;
    max-height: 400px;
    word-wrap: break-all;
    word-break: break-all;
    background-color: white;
    padding: 0px 10px;
    cursor: text;
    overflow: hidden;
    overflow-y: scroll;
    overflow-y: overlay;
  }

  p {
    display: flex;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const RequiredDot = styled.div`
  margin: 2px 0;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background-color: ${({ theme }) =>
    theme.colors.feedbackState.critical.default};
`;

// export const TextEditorContainer = styled.div`
//   /* border: 1px solid ${({ theme }) => theme.colors.gray[50]}; */
//   border-radius: 8px;
//   overflow: hidden;
//   margin-top: 20px;
//   .rdw-editor-toolbar {
//     border: none;
//   }

//   .DraftEditor-editorContainer {
//     min-height: calc(var(--app-height) - 250px);

//     word-wrap: break-all;
//     word-break: break-all;
//     background-color: white;
//     padding: 0px 10px;
//     cursor: text;

//     overflow: hidden;

//     max-height: calc(var(--app-height) - 250px);
//     overflow-y: scroll;
//     overflow-y: overlay;
//   }

//   ${(props) => {
//     if (props.fullscreen)
//       return `

// position: fixed;
// width: 100vw;
// height: var(--app-height);
// left:0;
// top: 0;

// color: white;
// z-index: 10;

// `;
//   }}
// `;
